import { SET_SHOW_LOGIN_POPUP } from './configTypes';

export const setShowLoginSignup = (payload) => ({
  type: SET_SHOW_LOGIN_POPUP,
  payload,
});
